import { render, staticRenderFns } from "./Revenue-page.vue?vue&type=template&id=59f9333a&scoped=true&"
import script from "./Revenue-page.vue?vue&type=script&lang=js&"
export * from "./Revenue-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f9333a",
  null
  
)

export default component.exports